export default "__VITE_ASSET__C0$8PY2K__"